// Import Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import logError from '~/common/utils/errorLogging.js';

import ErrorView from '~/views/ErrorView';

class ErrorBoundary extends Component {
    state = {
        hasError: false
    };

    componentDidCatch(err) {
        // Display loading spinner
        this.setState({ hasError: true });
        // You can also log the error to an error reporting service
        if (this.props.sendErrorsToLog) logError(err);
    }

    render() {
        return this.state.hasError ?
            <ErrorView />
            :
            this.props.children;
    }
}

ErrorBoundary.propTypes = {
    sendErrorsToLog: PropTypes.bool
};

export default ErrorBoundary;
